export type ChatRole = "user" | "assistant" | "system";

export interface ChatMessage {
  kind: "message";
  id: string;
  role: ChatRole;
  content: string;
}

export interface ChatError {
  kind: "error";
  id: string;
  content: string;
}

export type ChatTranscriptItem = ChatMessage | ChatError;

export interface ReferencedFile {
  resourceId: string;
  name: string;
  fileRevisionId?: string;
}

// The upload display name is user-editable and may already carry the extension,
// so only append it when it isn't already there (case-insensitive) to avoid
// duplicated suffixes like "report.pdf.pdf".
export function buildReferencedFileName(displayName: string, extension: string): string {
  if (!extension) return displayName;
  const suffix = `.${extension}`;
  return displayName.toLowerCase().endsWith(suffix.toLowerCase()) ? displayName : `${displayName}${suffix}`;
}
